import { createContext } from "react"

export type AuthStatus = "initializing" | "signedOut" | "signedIn"

export interface AuthContextValue {
  readonly status: AuthStatus
  readonly accessToken: string | undefined
  readonly displayName: string | undefined
  /**
   * The OIDC subject claim — the same value the native apps call `user.id` and
   * hand to Brightcove as the analytics viewer. Opaque, and not a display name.
   */
  readonly userId: string | undefined
  readonly signIn: () => Promise<void>
  readonly signOut: () => Promise<void>
  /** Drops the cached token so the next request forces a renew. */
  readonly clearToken: () => void
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined)
